<script setup lang="ts">
import { Check } from 'lucide-vue-next';

import { GroupInfoBlock } from '@/views/Groups/components';

import type { GroupSimplified } from '@/types/groups';
import type { SelectOption } from '@/types/components';

defineProps<{
  option: SelectOption & {
    data: GroupSimplified;
  };
  isSelected: (
    option: SelectOption & {
      data: GroupSimplified;
    }
  ) => boolean;
}>();
</script>
<template>
  <GroupInfoBlock
    class="w-[calc(100%-3rem)] hover:bg-blue-50 items-center"
    group-details-class="w-full"
    is-small
    is-option
    truncate
    :name="option.data.name"
    :description="option.data.description"
  />
  <Check
    v-if="isSelected(option)"
    data-testid="group-option-is-checked-icon"
    class="h-4 w-4 stroke-iamip-accent-blue shrink-0 ml-auto"
  />
</template>
